module.exports = __webpack_public_path__ + "img/card_hole.84fb0955.svg";